import { gql } from '__generated__'

/** Stores the cookie choice for the current user or guest session (BE-342). */
export const SET_CONSENT = gql(`
  mutation setConsent($data: ConsentInput!) {
    setConsent(data: $data)
  }
`)
